module.exports = __webpack_public_path__ + "img/logo.f4f3422c.svg";